import type { EventBusPayload } from "@/modules/event-bus";

import { useTranslation } from "react-i18next";

import { isJobModuleFailedNotificationPayload } from "@/entities/broadcast-notification";
import { useUpdateJobModuleStateQueryData } from "@/entities/job-module";
import { useInvalidateNotifications } from "@/entities/notifications";
import { useGetSettingsNotifications } from "@/entities/settings";
import { useAppNotification } from "@/modules/app-notification";
import { useAsyncActions } from "@/modules/async-actions";

import { notifyJobModuleFailed } from "./job-module-action-failed.helper";

export const useJobModuleActionFailed = () => {
  const { t } = useTranslation();
  const { notify } = useAppNotification();
  const { updateJobModuleState } = useUpdateJobModuleStateQueryData();
  const { setFailedState } = useAsyncActions();
  const { invalidateNotifications } = useInvalidateNotifications();
  const { isBroadcastNotificationEnabled } = useGetSettingsNotifications();
  const runAction = (payload: EventBusPayload) => {
    if (!isJobModuleFailedNotificationPayload(payload)) return;
    if (isBroadcastNotificationEnabled(payload.job_module.module_tag)) {
      const title = t("broadcast:jobModuleFailed", {
        moduleName: payload.job_module.module_name,
      });
      notifyJobModuleFailed({ notify, title, payload });
    }

    setFailedState("jobmodule", payload.job_module.id);
    updateJobModuleState(payload.job_module.id, "Failed");

    invalidateNotifications("*");
  };

  return { runAction };
};
